/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bulkCandidateWhatsAppResultDataSchema = z.object({
	queued: z.number(),
	skipped: z.array(
		z.object({
			candidateId: z.string(),
			reason: z.union([z.literal('no_phone'), z.literal('opted_out'), z.literal('missing_parameter_data')]),
		}),
	),
})

export type BulkCandidateWhatsAppResultDataSchema = z.infer<typeof bulkCandidateWhatsAppResultDataSchema>
